import type { ActionFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationDeleteCollectionArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getCollectionKey,
  getCollectionsKey,
} from '../../utils/keys/collection.key.js'

export const useDeleteCollection = (options?: {
  fields?: ActionFields
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeleteCollectionArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationDeleteCollectionArgs>(
    input => client.collections.delete(input.id),
    {
      onSettled: (data, error, input) => {
        const collectionKey = getCollectionKey({ variables: input })
        queryClient.removeQueries(collectionKey)

        const collectionsKey = getCollectionsKey()
        queryClient.invalidateQueries(collectionsKey)
      },
      ...useMutationOptions,
    },
  )
}
